import * as focusTrap from 'focus-trap';
import { KEYS } from '../constants';
import Cookies from 'js-cookie';
import * as Coveo from 'coveo-search-ui';
import { getTimesConfig, buildOptionsHtml } from '../helpers/times';

class ScheduleATour {
  constructor({
    dom,
    openPrimaryNavChildMenu,
    closePrimaryNavChildMenu,
    displayPrimaryNavPanel,
    focusOutPrimaryNav
  }) {
    this.dom = {
      ...dom,
      $trigger: dom.$header._$('.schedule-a-tour-trigger'),
      $panel: dom.$header._$('.schedule-a-tour'),
      $datePicker: dom.$header._$('duet-date-picker'),
      $timeSelect: dom.$header._$('.schedule-a-tour__time select'),
      $communityPage: document.querySelector('.community-landing-page-coveo')
    };

    this.openPrimaryNavChildMenu = openPrimaryNavChildMenu;
    this.closePrimaryNavChildMenu = closePrimaryNavChildMenu;
    this.displayPrimaryNavPanel = displayPrimaryNavPanel;
    this.focusOutPrimaryNav = focusOutPrimaryNav;

    // this.location = Cookies.get('ssl-location');
    // this.apiKey = this.dom.$panel.dataset.apiK;
    if (this.dom.$datePicker) this.dom.$datePicker.firstDayOfWeek = 0;
    this.wasValidated = false;

    // this.miles = 0.000621371;
    // this.km = 0.001;
    // this.unit = this.dom.$panel.dataset.unit === 'mi' ? this.miles : this.km;

    // if (this.dom.$communityPage) {
    //   this.ssl_latitude = this.dom.$communityPage.dataset.sslLatitude;
    //   this.ssl_longitude = this.dom.$communityPage.dataset.sslLongitude;
    //   this.ssl_communityname = this.dom.$communityPage.dataset.sslCommunityname;
    //   this.ssl_thumbnailimage =
    //     this.dom.$communityPage.dataset.sslThumbnailimage;
    //   this.ssl_mainimagedesktop =
    //     this.dom.$communityPage.dataset.sslMainimagedesktop;
    //   this.ssl_pricingandavailabilityphone =
    //     this.dom.$communityPage.dataset.sslPricingandavailabilityphone;
    //   this.ssl_residentsandfamilyphone =
    //     this.dom.$communityPage.dataset.sslResidentsandfamilyphone;
    //   this.ssl_contextlanguage =
    //     this.dom.$communityPage.dataset.sslContextlanguage;
    //   this.ssl_communityid = this.dom.$communityPage.dataset.sslCommunityid;
    // }

    // Current community
    // if (Cookies.get('current_community')) {
    //   this.currentCommunity = JSON.parse(Cookies.get('current_community'));
    // } else if (this.dom.$communityPage && this.ssl_communityid) {
    //   this.currentCommunity = {
    //     ssl_latitude: this.ssl_latitude,
    //     ssl_longitude: this.ssl_longitude,
    //     ssl_communityname: this.ssl_communityname,
    //     ssl_thumbnailimage: this.ssl_thumbnailimage
    //       ? this.ssl_thumbnailimage
    //       : this.ssl_mainimagedesktop,
    //     ssl_pricingandavailabilityphone: this.ssl_pricingandavailabilityphone,
    //     ssl_residentsandfamilyphone: this.ssl_residentsandfamilyphone,
    //     ssl_contextlanguage: this.ssl_contextlanguage,
    //     ssl_communityid: this.ssl_communityid,
    //     ssl_communitylink: this.communityUrl
    //   };
    // }

    // // Recently viewed communities
    // if (Cookies.get('recent_communities')) {
    //   this.recentlyViewedCommunities = JSON.parse(
    //     Cookies.get('recent_communities')
    //   );
    // }

    // if (this.location) {
    //   this.userLocation = JSON.parse(this.location);
    // }

    //this.recentCommunitiesHandler();

    this.id = 'schedule-a-tour';
    this.expandedClass = 'schedule-a-tour-trigger--expanded';
    // this.configureEndpoint();
    // this.addCoveoEventHandlers();
    this.addListeners();
    //this.getCommunity();
    this.initiateFocusTrap();

    // if (!this.location) {
    //   const changeCommunityLink = document.querySelector(
    //     '.schedule-a-tour-current-community__cta'
    //   );
    //   changeCommunityLink.href =
    //     this.dom.$panel.dataset.changeCommunityLinkNoLocation;
    // }
    this.timeHandler();
  }

  addListeners() {
    this.dom.$trigger._on('keydown', this.handleTriggerKeyDown.bind(this));
    this.dom.$trigger._on('click', this.handleTriggerClick.bind(this));
    document._on('click', this.outterClickHandler.bind(this));

    this.dom.$datePicker.addEventListener('duetChange', event => {
      this.currentDate = event.detail.valueAsDate;
      this.timeHandler();
    });

    this.dom.$datePicker.addEventListener('duetBlur', event => {
      const $input = this.dom.$datePicker.querySelector('input');
      const splited = this.dom.$datePicker.value.split('-');
      $input.value = `${this.checkZero(splited[1])}/${this.checkZero(
        splited[2]
      )}/${splited[0]}`;
    });
  }

  checkZero(value) {
    if (value.split('')[0] === '0') return value.split('')[1];

    return value;
  }

  // addCoveoEventHandlers() {
  //   Coveo.$$(this.dom.$panel).on(
  //     'buildingQuery',
  //     this.handleCoveoBuildingQuery.bind(this)
  //   );
  //   Coveo.$$(this.dom.$panel).on(
  //     'preprocessResults',
  //     this.handleCoveoPreprocessResults.bind(this)
  //   );
  // }

  timeHandler() {
    this.dom.$timeSelect.innerHTML = '';

    const todayFormated = new Date()
      .toLocaleString('sv', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
      .split(' ')[0]
      .split('/')
      .reverse()
      .join('-');
    const isToday = this.dom.$datePicker.value === todayFormated;
    const today = new Date().toLocaleString('en-US', {
      timeZone: 'America/New_York'
    });

    const { parsedOptions, minDatePicker } = getTimesConfig(
      this.dom.$datePicker,
      isToday,
      today
    );
    this.dom.$datePicker.min = minDatePicker;

    if (parsedOptions.length === 1) {
      const $dateInput =
        this.dom.$datePicker.querySelector('.duet-date__input');
      const errorMessage = this.dom.$datePicker.dataset.pristineNoTimes;
      setTimeout(() => {
        $dateInput.pristine.errors = [];
        $dateInput.pristine.self.addError($dateInput, errorMessage);
      });
    }

    if (!this.wasValidated) {
      this.dom.$datePicker.value = minDatePicker;
      this.wasValidated = true;
      this.timeHandler();
      return;
    }

    const optionsHtml = buildOptionsHtml(parsedOptions);

    this.dom.$timeSelect.innerHTML = optionsHtml;
  }

  // configureEndpoint() {
  //   if (this.dom.$panel.dataset.organizationId.length > 0) {
  //     this.organizationId = this.dom.$panel.dataset.organizationId;
  //     Coveo.SearchEndpoint.configureCloudV2Endpoint(
  //       this.organizationId,
  //       this.apiKey
  //     );
  //   } else Coveo.SearchEndpoint.configureSampleEndpointV2();
  // }

  // locationInit() {
  //   fetch(`${this.dom.$panel.dataset.geoEndpoint}`)
  //     .then(data => data.json())
  //     .then(res => {
  //       this.lat = res.Latitude;
  //       this.long = res.Longitude;
  //       Coveo.init(this.dom.$panel);

  //       Coveo.logSearchEvent(
  //         this.dom.$panel,
  //         {
  //           name: 'scheduleATour',
  //           type: ''
  //         },
  //         {
  //           latitude: this.lat,
  //           longitude: this.long
  //         }
  //       );

  //       Coveo.executeQuery(this.dom.$panel);
  //     })
  //     .catch(e => {
  //       this.lat = null;
  //       this.long = null;
  //     });
  // }

  // getGeoQuery(lat, long) {
  //   return `$qf(function:'dist(@ssl_latitude_d,@ssl_longitude_d,${lat},${long})', fieldName: 'distance')`;
  // }

  // async handleCoveoBuildingQuery(e, args) {
  //   if (this.userLocation) {
  //     this.lat = this.userLocation.lat;
  //     this.long = this.userLocation.lng;
  //   }

  //   const expression = this.getGeoQuery(this.lat, this.long);

  //   args.queryBuilder.advancedExpression.add(expression);
  //   args.queryBuilder.advancedExpression.add(
  //     "@ssl_pagetype=='community_pagetype'"
  //   );
  //   args.queryBuilder.sortCriteria = '@distance Ascending';

  //   //eslint-disable-next-line no-undef
  //   await new Promise(resolve => {
  //     requestAnimationFrame(() => resolve());
  //   });
  // }

  // handleCoveoPreprocessResults(e, args) {
  //   const results = args.results.results;
  //   if (results.length) {
  //     const {
  //       distance,
  //       ssl_latitude_d,
  //       ssl_longitude_d,
  //       ssl_communityname,
  //       ssl_thumbnailimage,
  //       ssl_pricingandavailabilityphone,
  //       ssl_residentsandfamilyphone,
  //       ssl_communityid,
  //       uri,
  //       ssl_mainimagedesktop
  //     } = results[0].raw;
  //     const formatDistance = (distance * this.unit).toFixed(2);
  //     this.currentCommunity = {
  //       ssl_latitude: ssl_latitude_d,
  //       ssl_longitude: ssl_longitude_d,
  //       ssl_communityname,
  //       ssl_thumbnailimage: ssl_thumbnailimage
  //         ? ssl_thumbnailimage
  //         : ssl_mainimagedesktop,
  //       ssl_pricingandavailabilityphone,
  //       ssl_residentsandfamilyphone,
  //       ssl_communityid,
  //       ssl_communitylink: uri,
  //       ssl_distance: formatDistance
  //     };
  //     this.getCommunity();
  //     const currentCommunityString = JSON.stringify(this.currentCommunity);
  //     Cookies.set('current_community', currentCommunityString);
  //   }
  // }

  // getCommunity() {
  //   if (this.currentCommunity) {
  //     const {
  //       ssl_communityname,
  //       ssl_thumbnailimage,
  //       ssl_pricingandavailabilityphone,
  //       ssl_residentsandfamilyphone,
  //       ssl_distance,
  //       ssl_communitylink
  //     } = this.currentCommunity;
  //     const communityHeader = document.querySelector(
  //       '.schedule-a-tour-current-community__card-name'
  //     );
  //     const communityImage = document.querySelector(
  //       '.schedule-a-tour-current-community__image'
  //     );
  //     const availabilityPhone = document.querySelector(
  //       '.schedule-a-tour__availability-contact'
  //     );
  //     const residentsPhone = document.querySelector(
  //       '.schedule-a-tour__residents-contact'
  //     );
  //     const communityLink = document.querySelector(
  //       '.schedule-a-tour-current-community__card'
  //     );
  //     const title = document.querySelector(
  //       '.schedule-a-tour-current-community__contacts-title'
  //     );

  //     if (ssl_communityname && ssl_communitylink) {
  //       communityLink.href = ssl_communitylink;
  //       communityHeader.textContent = ssl_communityname;
  //       communityImage.src = ssl_thumbnailimage;
  //       communityLink.alt = ssl_communityname;
  //       if (availabilityPhone) {
  //         availabilityPhone.querySelector('.btn__label').textContent =
  //           ssl_pricingandavailabilityphone;
  //         availabilityPhone.href = `tel:${ssl_pricingandavailabilityphone}`;

  //         if (ssl_pricingandavailabilityphone) {
  //           availabilityPhone.style.display = 'flex';
  //         } else {
  //           availabilityPhone.style.display = 'none';
  //         }
  //       }
  //       if (residentsPhone) {
  //         residentsPhone.querySelector('.btn__label').textContent =
  //           ssl_residentsandfamilyphone;
  //         residentsPhone.href = `tel:${ssl_residentsandfamilyphone}`;

  //         if (ssl_residentsandfamilyphone) {
  //           residentsPhone.style.display = 'flex';
  //         } else {
  //           residentsPhone.style.display = 'none';
  //         }
  //       }

  //       if (!availabilityPhone && !residentsPhone && title) {
  //         title.style.display = 'none';
  //       } else {
  //         title.style.display = 'unset';
  //       }
  //     } else {
  //       if (!availabilityPhone) availabilityPhone.style.display = 'none';
  //       if (!residentsPhone) residentsPhone.style.display = 'none';
  //       if (!availabilityPhone && !residentsPhone && title)
  //         title.style.display = 'none';
  //     }

  //     if (ssl_distance) {
  //       const communityDistance = document.querySelector(
  //         '.schedule-a-tour-current-community__card-distance'
  //       );
  //       communityDistance.textContent = `${ssl_distance} ${this.dom.$panel.dataset.unitLabel}`;
  //     }
  //   }
  //   //else {
  //   //     this.locationInit();
  //   //   }
  // }

  // recentCommunitiesHandler() {
  //   const communityPage = document.querySelector(
  //     '.community-landing-page-coveo'
  //   );
  //   if (!communityPage) {
  //     if (
  //       this.recentlyViewedCommunities &&
  //       this.recentlyViewedCommunities.length > 2
  //     ) {
  //       const recentCommunitiesWrapper = document.querySelector(
  //         '.primary-nav__recently-viewed-communities'
  //       );
  //       this.recentlyViewedCommunities.reverse();
  //       this.recentlyViewedCommunities.map(el => {
  //         if (el.ssl_communityid !== this.currentCommunity.ssl_communityid) {
  //           const communityLink = document.createElement('a');
  //           communityLink.href = el.ssl_communitylink;
  //           communityLink.classList.add(
  //             'primary-nav__recently-viewed-communities-link'
  //           );
  //           const communityImage = document.createElement('img');
  //           communityImage.src = `${el.ssl_thumbnailimage}`;
  //           communityImage.classList.add(
  //             'primary-nav__recently-viewed-communities-image'
  //           );
  //           const communityInfo = document.createElement('div');
  //           communityInfo.classList.add(
  //             'primary-nav__recently-viewed-communities-info'
  //           );
  //           const communityTitle = document.createElement('span');
  //           communityTitle.classList.add(
  //             'primary-nav__recently-viewed-communities-title'
  //           );
  //           communityTitle.textContent = el.ssl_communityname;
  //           const communityDistance = document.createElement('span');
  //           communityDistance.classList.add(
  //             'primary-nav__recently-viewed-communities-distance'
  //           );
  //           communityDistance.textContent = el.ssl_distance
  //             ? `${el.ssl_distance} ${this.dom.$panel.dataset.unitLabel}`
  //             : '';

  //           communityInfo.append(communityTitle);
  //           communityInfo.append(communityDistance);
  //           communityLink.append(communityImage);
  //           communityLink.append(communityInfo);
  //           recentCommunitiesWrapper.append(communityLink);
  //         }
  //       });
  //     } else {
  //       const communitiesColumn = document.querySelector(
  //         '.schedule-a-tour__content'
  //       ).nextElementSibling;
  //       communitiesColumn.remove();
  //     }
  //   }
  // }

  handleTriggerKeyDown(e) {
    switch (e.keyCode) {
      case KEYS.ESC:
        this.handleClose();
        break;
      case KEYS.DOWN:
      case KEYS.ENTER:
        e.preventDefault();
        this.handleTriggerClick(e);
        this.panelFocusTrap.activate();
        break;
    }
  }

  outterClickHandler(e) {
    const headerPanel = document.querySelector('.header__panel');
    if (headerPanel && !headerPanel.contains(e.target)) {
      this.handleClose();
    }
  }

  handleTriggerClick() {
    if (this.dom.$trigger.classList.contains(this.expandedClass)) {
      this.handleClose();
    } else {
      this.openPrimaryNavChildMenu();
      this.dom.$trigger.classList.add(this.expandedClass);
      this.displayPrimaryNavPanel(this.id);
      this.focusOutPrimaryNav();
    }
  }

  handleClose() {
    this.focusOut();
    this.closePrimaryNavChildMenu();
  }

  initiateFocusTrap() {
    this.panelFocusTrap = focusTrap.createFocusTrap(this.dom.$childNavWrapper, {
      allowOutsideClick: false,
      onDeactivate: this.handleClose.bind(this),
      initialFocus: () => {
        return this.dom.$panel.getElementsByTagName('INPUT')[0];
      }
    });
  }

  focusOut() {
    this.dom.$trigger.classList.remove(this.expandedClass);
  }
}

export default ScheduleATour;
